import { LoanEquipmentDTO } from "../models/LoanEquipment/LoanEquipmentDTO";
import { LoanEquipmentSearchResultDTO } from "../models/LoanEquipment/LoanEquipmentSearchResultDTO";
import { AssistanceLoanEquipmentDTO } from "../models/Assistance/AssistanceLoanEquipmentDTO";
import { EditAssistanceLoanEquipmentDTO } from "../models/Assistance/EditAssistanceLoanEquipmentDTO";
import { APIService } from "./APIService";
import { Parameter } from "../models/Parameter";
import { PaginatedList } from "../helpers/PaginatedList";

export class LoanEquipmentService {
    async getAvailable(name?: string): Promise<LoanEquipmentDTO[]> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/LoanEquipment/GetAvailable${name ? `?name=${name}` : ''}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );

            return response.data;
        } catch (error) {
            return [];
        }
    }

    async getByAssistance(assistanceId: number): Promise<AssistanceLoanEquipmentDTO[]> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Assistance/GetLoanEquipmentByAssistance?assistanceId=${assistanceId}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );

            return response.data;
        } catch (error) {
            return [];
        }
    }    
    
    async updateLoanEquipment(data: EditAssistanceLoanEquipmentDTO): Promise<boolean> {
        try {
            const response = await APIService.Axios().put(
                `${APIService.GetURL()}/Assistance/UpdateLoanEquipmentContent`,
                data,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );

            return response.status === 200;
        } catch (error) {
            return false;
        }
    }

    async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<LoanEquipmentSearchResultDTO>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/LoanEquipment/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<LoanEquipmentSearchResultDTO>(
                false,
                "Erro ao ligar ao servidor para obter os equipamentos de empréstimo",
                "",
                [],
                0,
            );
        }
    }
}
